var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_116507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1025_116507)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1144 50.4155H55.5754C51.9828 50.4155 49.0703 53.3212 49.0703 56.9055V95.6958C49.0703 99.2802 51.9828 102.186 55.5754 102.186H87.1144C90.7072 102.186 93.6195 99.2802 93.6195 95.6958V56.9055C93.6195 53.3212 90.7072 50.4155 87.1144 50.4155Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.515 50.4155H114.976C111.383 50.4155 108.471 53.3212 108.471 56.9055V66.1471C108.471 69.7315 111.383 72.6371 114.976 72.6371H146.515C150.108 72.6371 153.02 69.7315 153.02 66.1471V56.9055C153.02 53.3212 150.108 50.4155 146.515 50.4155Z",
    fill: "#2D67B0",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.515 87.4536H114.976C111.383 87.4536 108.471 90.3592 108.471 93.9435V147.635C108.471 151.219 111.383 154.125 114.976 154.125H146.515C150.108 154.125 153.02 151.219 153.02 147.635V93.9435C153.02 90.3592 150.108 87.4536 146.515 87.4536Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1144 117.084H55.5754C51.9828 117.084 49.0703 119.99 49.0703 123.574V147.632C49.0703 151.216 51.9828 154.122 55.5754 154.122H87.1144C90.7072 154.122 93.6195 151.216 93.6195 147.632V123.574C93.6195 119.99 90.7072 117.084 87.1144 117.084Z",
    fill: "#2D67B0",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1025_116507",
    x: -19.6,
    y: -19.6,
    width: 239.2,
    height: 239.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1025_116507"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1025_116507"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1025_116507",
    result: "effect2_dropShadow_1025_116507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1025_116507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_116507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.631db33feacdc49795b97889e556af43.svg";
export { ForwardRef as ReactComponent };